import { render, staticRenderFns } from "./extra-prozesse.vue?vue&type=template&id=1f7319cd&scoped=true&lang=pug&"
import script from "./extra-prozesse.vue?vue&type=script&lang=js&"
export * from "./extra-prozesse.vue?vue&type=script&lang=js&"
import style0 from "./extra-prozesse.vue?vue&type=style&index=0&id=1f7319cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7319cd",
  null
  
)

export default component.exports